// extracted by mini-css-extract-plugin
export default {"page":"max-characters-message_page__5FE1v"};